<template>
  <div class="footer">
    <P>建议分辨率：1366*768及以上，<a href="http://downs.xt12366.com/ChromeSetup.exe"
                            target="_blank"
                            style="color:#29a5ff;text-decoration:underline;">谷歌浏览器</a>&nbsp;&nbsp;<a
      href="https://ie.sogou.com/" target="_blank"
      style="color:#29a5ff;text-decoration:underline;">搜狗浏览器</a></P>
    <p>本系统已通过ISO27001信息安全管理体系认证 &copy; 泰安协同软件有限公司</p>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>
  .footer {
    box-sizing: border-box;
    padding: 26px;
    width: 100%;
    height: 121px;
    background: #ffffff;
    font-size: 14px;
    color: #555555;
    text-align: center;
  }

  .footer p {
    margin: 0;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue